import { IconWrapper } from '../runtime';
export default IconWrapper('folder_team_format_s', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M1.5 13.5C0.671573 13.5 0 12.8284 0 12L0 1.5C0 0.671573 0.671573 0 1.5 0L4.5 0C4.82456 0 5.14036 0.105267 5.4 0.3L6.6 1.2C6.85964 1.39473 7.17544 1.5 7.5 1.5L14.5 1.5C15.3284 1.5 16 2.17157 16 3L16 12C16 12.8284 15.3284 13.5 14.5 13.5L1.5 13.5Z",
      "fill": "#0065DC"
    }
  }), h("path", {
    "attrs": {
      "d": "M1.5 15C0.671573 15 0 14.3284 0 13.5L0 4.5C0 3.67157 0.671573 3 1.5 3L14.5 3C15.3284 3 16 3.67157 16 4.5L16 13.5C16 14.3284 15.3284 15 14.5 15L1.5 15Z",
      "fill": "#1983FF"
    }
  }), h("path", {
    "attrs": {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M7.54309 6.72139C7.54309 7.41563 6.98028 7.97843 6.28602 7.97843C5.59177 7.97843 5.02896 7.41563 5.02896 6.72139C5.02896 6.02715 5.59177 5.46436 6.28602 5.46436C6.98028 5.46436 7.54309 6.02715 7.54309 6.72139ZM9.71439 7.97843C10.4086 7.97843 10.9715 7.41563 10.9715 6.72139C10.9715 6.02715 10.4086 5.46436 9.71439 5.46436C9.02013 5.46436 8.45732 6.02715 8.45732 6.72139C8.45732 7.41563 9.02013 7.97843 9.71439 7.97843Z",
      "fill": "white"
    }
  }), h("path", {
    "attrs": {
      "d": "M5.99988 9.00702C4.89538 9.00702 4 9.90237 4 11.0068L4 12.0001H8.57115L8.57115 11.0068C8.57115 9.90237 7.67578 9.00702 6.57127 9.00702H5.99988Z",
      "fill": "white"
    }
  }), h("path", {
    "attrs": {
      "d": "M9.7139 11.0068L9.7139 12H11.9995L12 11.0068C12 9.90237 11.1046 9.00702 10.0001 9.00702H9.42873C9.29154 9.00702 9.15758 9.02083 9.02816 9.04715C9.45733 9.58448 9.7139 10.2657 9.7139 11.0068Z",
      "fill": "white"
    }
  })]);
});